import { createSelector } from 'reselect';
import { getState } from 'store/utils';

export const getAppStore = createSelector(getState, (state) => state.app);
export const getAppTabTitle = createSelector(getAppStore, (state) => state.appTabTitle);
export const getProjectMeta = createSelector(getAppStore, (state) => state.meta);
